// Maps a Stripe checkout failure to what the payer should actually read.
//
// Two shapes arrive here, and the difference matters:
//
//  1. Stripe RETURNS { error } for payment problems — declines, incomplete
//     fields. Those messages are written for the payer and say what to fix,
//     so they are shown verbatim.
//
//  2. Stripe THROWS for integration faults — notably submitting before the
//     PaymentElement has mounted and emitted `ready`, which produced
//     IntegrationError KBT-FRONTEND-2 on the live site. Nothing in that
//     text helps a payer, and it is our bug, not theirs, so it becomes a
//     plain instruction to refresh. The real error goes to Sentry instead.
//
// Everything else is deliberately generic: api_error and friends can carry
// upstream internals that should not be shown to a member.
const UNEXPECTED = 'An unexpected error occurred.';
const INTEGRATION =
  'Something went wrong setting up the payment form. Please refresh the page and try again.';

const PAYER_FACING_TYPES = ['card_error', 'validation_error'];

export const getCheckoutErrorMessage = (error) => {
  if (!error) return null;

  if (PAYER_FACING_TYPES.includes(error.type)) {
    return error.message || UNEXPECTED;
  }

  // A thrown Error has no Stripe `type`. IntegrationError is the one we
  // have actually seen in production; treat any thrown Error the same way,
  // since a refresh is the useful advice for all of them.
  if (error instanceof Error && !error.type) {
    return INTEGRATION;
  }

  return UNEXPECTED;
};
